import axios from 'axios'
import { decode } from 'jsog'

const toData = response => decode(response.data)

export function getScoreMatrix(scanId): Promise {
  return axios.get(`/bw/score/${scanId}`).then(toData)
}

export function getPhaseTotals(scanId): Promise {
  return axios.get(`/bw/score/phasetotals/${scanId}`).then(toData)
}

export function getSteeringWheelTotals(scanId): Promise {
  return axios.get(`/bw/score/steeringwheeltotals/${scanId}`).then(toData)
}

export function getSteeringWheels(): Promise {
  return axios.get('/bw/static/steeringwheels').then(toData)
}

export function getQuestionPhases(): Promise {
  return axios.get('/bw/static/questionphases').then(toData)
}

export function getTotal(scanId): Promise {
  return axios.get(`/bw/score/${scanId}`).then(toData)
}



// WEBPACK FOOTER //
// ./src/services/score-service.js